module.exports = __webpack_public_path__ + "img/doctors-banner.4426a221.png";